export default __webpack_public_path__ + "static/media/drawing.b68fafa2.svg";